/**
 * Classe model pour la réponse à l'appel au calcul 
 * PrestationAlMiddle v1/simuler
 */
export class DroitSimulationModel {

    /**
     * Valeurs possibles : 
     * true = droit prestation possible d'après la simulation
     * false = pas de droit prestation possible d'après la simulation
     */
    possedeDesDroits: boolean;

    /**
     * 
     */
    montantDroit: number;

    /**
     * Constructeur
     */
    constructor() { }
}
